// extracted by mini-css-extract-plugin
export default {"sidebar":"Navbar_sidebar__pNbKj","logo":"Navbar_logo__99MIj","navList":"Navbar_navList__+Jq23"};